import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";

export default class OrderNotesPopupController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.config = cartConfig;
    $ctrl.order = Object.assign({}, options.model, options.order);
    $ctrl.title = options.title || "Order Notes";
  }
}
